<template>
  <div 
    @click.stop="closeFunc" 
    id="hide-modal-btn"
    :title="title"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'CloseBtn',
  components: {
  },
  props: {
    closeFunc: Function,
    title: String
  },
  data() {
    return {
    }
  },
  computed: {},
  methods: {
  },
  mounted() {
  }
}

</script>

<style scoped>

#hide-modal-btn {
  cursor: pointer;
  padding: .3rem;
  display: flex;
  border-radius: 5px;
  transition: all .3s;
}
#hide-modal-btn:hover {
  background-color: rgb(241, 162, 162);
}

</style>